import React from 'react';
import Icon from '../../../components/AppIcon';

const LabResultsTable = ({ results, onResultClick }) => {
  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'critical':
        return 'text-destructive';
      case 'abnormal':
        return 'text-warning';
      case 'normal':
        return 'text-success';
      default:
        return 'text-foreground';
    }
  };

  const getSeverityIcon = (severity) => {
    switch (severity) {
      case 'critical':
        return 'AlertCircle';
      case 'abnormal':
        return 'AlertTriangle';
      case 'normal':
        return 'CheckCircle';
      default:
        return 'Circle';
    }
  };

  const getTrendIcon = (trend) => {
    switch (trend) {
      case 'up':
        return 'TrendingUp';
      case 'down':
        return 'TrendingDown';
      case 'stable':
        return 'Minus';
      default:
        return null;
    }
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-border">
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Test Name</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Result</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Reference Range</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Unit</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Status</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Trend</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Date</th>
          </tr>
        </thead>
        <tbody>
          {results?.map((result) => (
            <tr
              key={result?.id}
              onClick={() => onResultClick(result)}
              className="border-b border-border hover:bg-muted cursor-pointer transition-smooth"
            >
              <td className="py-3 px-4">
                <div className="flex items-center gap-2">
                  <Icon
                    name={getSeverityIcon(result?.severity)}
                    size={16}
                    className={getSeverityColor(result?.severity)}
                  />
                  <span className="text-sm font-medium text-foreground">{result?.testName}</span>
                </div>
              </td>
              <td className="py-3 px-4">
                <span className={`text-sm font-semibold ${getSeverityColor(result?.severity)}`}>
                  {result?.value}
                </span>
              </td>
              <td className="py-3 px-4">
                <span className="text-sm text-muted-foreground">{result?.referenceRange}</span>
              </td>
              <td className="py-3 px-4">
                <span className="text-sm text-muted-foreground">{result?.unit}</span>
              </td>
              <td className="py-3 px-4">
                <span
                  className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                    result?.severity === 'critical' ?'bg-destructive/10 text-destructive'
                      : result?.severity === 'abnormal' ?'bg-warning/10 text-warning' :'bg-success/10 text-success'
                  }`}
                >
                  {result?.status}
                </span>
              </td>
              <td className="py-3 px-4">
                {result?.trend && (
                  <Icon
                    name={getTrendIcon(result?.trend)}
                    size={16}
                    className={
                      result?.trend === 'up' ?'text-destructive'
                        : result?.trend === 'down' ?'text-success' :'text-muted-foreground'
                    }
                  />
                )}
              </td>
              <td className="py-3 px-4">
                <span className="text-sm text-muted-foreground">{result?.date}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LabResultsTable;